import React from 'react'
import Header from "../components/header/header";
import VideoProduction from "../sections/VideoProduction/VideoProduction"
import Footer from "../components/footer/footer";

function videoprod() {
    return (
        <>
            <Header />
            <VideoProduction />
            <Footer />
        </>
    )
}

export default videoprod
